<ng-container *ngIf="vm$ | async as vm">
  <!-- Encabezado del día -->
  <div class="od-toolbar" style="margin-bottom:6px">
    <button type="button" class="od-btn od-btn-sm" (click)="volver.emit()" aria-label="Volver a la lista de archivos">
      <od-icon name="chev" style="transform:rotate(90deg)"></od-icon>Volver
    </button>
  </div>
  <div class="od-toolbar">
    <h4 style="font-size:20px;font-weight:700">{{ vm.titulo }}</h4>
    <span class="od-fin" style="display:inline-flex;gap:8px;align-items:center">
      <button type="button" class="od-btn" *ngIf="!previa" [disabled]="descargando || !vm.hayArchivo" (click)="descargar(vm)">
        <od-icon name="down"></od-icon>{{ descargando ? 'Descargando…' : 'Descargar' }}
      </button>
      <button type="button" class="od-btn" *ngIf="!previa && puedeEditar && vm.yaSubido" (click)="regenerar.emit({ fecha: fecha, subidoISO: vm.subidoISO })">
        <od-icon name="refresh"></od-icon>Regenerar
      </button>
    </span>
  </div>

  <!-- Vista previa: nada se envía hasta pulsar «Subir al buzón» -->
  <div class="od-alert od-alert-flat" *ngIf="previa && vm.datos" role="status">
    <od-icon name="eye" [size]="16"></od-icon>
    <div class="od-alert-tx"><b>{{ vm.aviso.split('. ')[0] }}.</b> <span class="od-muted">{{ vm.aviso.slice(vm.aviso.indexOf('. ') + 2) }}</span></div>
    <button type="button" class="od-btn od-btn-primary" *ngIf="puedeEditar" [disabled]="subiendo" (click)="subir.emit({ fecha: fecha, yaSubido: vm.yaSubido, subidoISO: vm.subidoISO })">
      <od-icon name="upload" [class.od-spin]="subiendo"></od-icon>{{ subiendo ? 'Subiendo…' : 'Subir al buzón' }}
    </button>
  </div>

  <!-- Pestañas -->
  <div class="od-tabs" role="tablist" aria-label="Archivos del día" *ngIf="vm.datos">
    <button type="button" class="od-tab" role="tab" [attr.aria-selected]="pestana === 'creditos'" (click)="elegir('creditos')">Giros · {{ vm.nGiros }}</button>
    <button type="button" class="od-tab" role="tab" [attr.aria-selected]="pestana === 'pagos'" (click)="elegir('pagos')">Pagos · {{ vm.nPagos }}</button>
    <button type="button" class="od-tab" role="tab" *ngIf="!previa" [attr.aria-selected]="pestana === 'historial'" (click)="elegir('historial')">Historial · {{ vm.eventos.length }}</button>
  </div>

  <!-- Error -->
  <div class="od-alert" *ngIf="vm.error" role="alert">
    <od-icon name="alert" [size]="16"></od-icon>
    <div class="od-alert-tx"><b>No se pudo traer el detalle del día.</b> {{ vm.error }}</div>
    <button type="button" class="od-btn od-btn-sm" (click)="recargar()">Reintentar</button>
  </div>

  <!-- Cargando -->
  <div *ngIf="vm.cargando && !vm.datos" aria-busy="true">
    <div class="od-skeleton" style="height:78px;margin-bottom:12px"></div>
    <div class="od-skeleton" style="height:36px;margin-bottom:6px" *ngFor="let i of esperando; trackBy: porIndice"></div>
  </div>

  <ng-container *ngIf="vm.datos as d">
    <!-- Historial -->
    <section *ngIf="pestana === 'historial'" class="od-seccion">
      <div class="od-empty" *ngIf="!vm.eventos.length">
        <od-icon name="history" [size]="28"></od-icon>
        <b>Este día no tiene historial</b>
        <span>Los días subidos antes de esta versión no guardaban quién ni cuándo.</span>
      </div>
      <div class="od-ev" *ngFor="let e of vm.eventos; trackBy: porIndice">
        <od-icon name="clock"></od-icon>
        <div class="od-ev-tx">{{ e.texto }}
          <div class="od-muted" *ngIf="e.motivo">Motivo: {{ e.motivo }}</div>
          <div class="od-muted" *ngIf="e.error">{{ e.error }}</div>
        </div>
        <span class="od-ev-tm">{{ e.cuando }}</span>
      </div>
    </section>

    <!-- Giros / Pagos -->
    <section *ngIf="pestana !== 'historial'" class="od-seccion" [style.opacity]="vm.cargando ? .6 : 1">
      <div class="od-empty" *ngIf="!vm.hayArchivo">
        <od-icon name="file" [size]="28"></od-icon>
        <b>{{ pestana === 'pagos' ? 'El archivo de pagos' : 'El archivo de giros' }} de este día no está en el buzón</b>
        <span>No se pudo subir o todavía no se generó.</span>
      </div>

      <ng-container *ngIf="vm.hayArchivo">
        <div class="od-kpis">
          <div class="od-kpi" [class.od-kpi-hi]="k.total" *ngFor="let k of vm.kpis; trackBy: porTitulo">
            <span class="od-muted">{{ k.titulo }}</span><b>{{ k.monto }}</b><span class="od-muted">{{ k.detalle }}</span>
          </div>
        </div>

        <div class="od-toolbar">
          <label class="od-input" style="min-width:240px">
            <od-icon name="search"></od-icon>
            <input type="search" [value]="texto" (input)="escribir($any($event.target).value)" placeholder="Buscar cédula o crédito" aria-label="Buscar por cédula o crédito">
          </label>
          <label class="od-select">
            <span>Comercio:</span>
            <select (change)="filtrarComercio($any($event.target).value)" aria-label="Filtrar por comercio">
              <option value="">Todos</option>
              <option *ngFor="let c of vm.comercios; trackBy: porIndice" [value]="c">{{ c }}</option>
            </select>
          </label>
          <button type="button" class="od-btn od-btn-sm od-fin" (click)="alternarColumnas()">{{ todasColumnas ? 'Columnas principales' : 'Todas las columnas' }}</button>
        </div>

        <div class="od-empty" *ngIf="!vm.filas.length">
          <od-icon name="search" [size]="28"></od-icon>
          <b>Ninguna fila coincide</b>
          <span>Prueba con otra cédula o crédito, o quita el filtro de comercio.</span>
        </div>

        <div class="od-table-wrap" *ngIf="vm.filas.length">
          <table class="od-table">
            <thead>
              <tr><th *ngFor="let c of vm.cols; trackBy: porIndice" [style.text-align]="c.num ? 'right' : 'left'">{{ c.titulo }}</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of vm.filas; trackBy: porIndice">
                <td *ngFor="let v of f; let j = index; trackBy: porIndice" [style.text-align]="vm.cols[j].num ? 'right' : 'left'" [style.font-variant-numeric]="vm.cols[j].num ? 'tabular-nums' : null">{{ v }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="od-toolbar" style="margin-top:8px" *ngIf="d.total > 0">
          <span class="od-muted">{{ (d.page - 1) * d.limit + 1 }}–{{ d.page * d.limit < d.total ? d.page * d.limit : d.total }} de {{ numero(d.total) }} filas</span>
          <span class="od-fin" style="display:inline-flex;gap:8px;align-items:center" *ngIf="d.total > d.limit">
            <button type="button" class="od-btn od-btn-sm" [disabled]="d.page === 1" (click)="ir(d.page - 1)">Anterior</button>
            <span class="od-muted">{{ d.page }} / {{ totalPaginas(d.total, d.limit) }}</span>
            <button type="button" class="od-btn od-btn-sm" [disabled]="d.page >= totalPaginas(d.total, d.limit)" (click)="ir(d.page + 1)">Siguiente</button>
          </span>
        </div>
      </ng-container>

      <p class="od-muted" style="margin-top:10px" *ngIf="!previa && vm.ultimo"><b style="color:var(--od-fg)">Historial:</b> {{ vm.ultimo }}</p>
    </section>
  </ng-container>
</ng-container>
